const services = {}

export const registerService = (name, service) => {
    services[name] = service
}

export const getService = name => services[name]
